<template>
  <CPreloader v-if="!ourText" />

  <div
    v-else
    class="feedback-form-layout"
  >
    <!-- Текст формы, который мы получаем из api -->
    <CCardWithBorder class="feedback-form-layout__block">
      <div class="feedback-form-layout-block-inner">
        <CMarkedText
          justify
          :text="ourText"
          class="feedback-form__our__text"
        />
      </div>
    </CCardWithBorder>

    <!-- Текстовое поле для ввода обращения -->
    <CCardWithBorder class="feedback-form-layout__block">
      <div class="feedback-form-layout-block-inner feedback-form-input">
        <FeedbackFormInput />
      </div>
    </CCardWithBorder>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';

  import { getFeedbackFormText } from '@/services/feedbackForm/api';
  import CCardWithBorder from '@/components/Cards/CCardWithBorder.vue';
  import FeedbackFormInput from './FeedbackFormInput.vue';
  import CMarkedText from '../CMarkedText/CMarkedText.vue';
  import CPreloader from '../CPreloader/CPreloader.vue';

  const ourText = ref('');

  getFeedbackFormText().then(async res => {
    ourText.value = res.data.data.attributes.feedback_form_text;
  });
</script>

<style>
  .feedback-form-layout {
    display: flex;
    gap: 24px;
    font-family: var(--g-font-family);

    &__block {
      flex: 1;
      flex-shrink: 0;
      width: calc(50% - 12px);
    }

    &-block-inner {
      overflow: hidden;
      border-radius: 30px;
      flex: 1;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
    }
  }

  .feedback-form {
    &__our__text {
      padding: 12px 24px;
      font-size: 18px;
      font-weight: 600;
    }
  }

  @media (--mobile) {
    .feedback-form-layout {
      flex-direction: column;
    }

    .feedback-form-layout__block {
      width: 100%;
    }

    .feedback-form {
      &__our__text {
        padding: 0 10px;

        ol {
          padding-left: 28px;
        }
      }

      &-input {
        height: 400px;
      }
    }
  }
</style>
